import { render, staticRenderFns } from "./SheetLayout.vue?vue&type=template&id=2ff74628"
import script from "./SheetLayout.vue?vue&type=script&lang=js"
export * from "./SheetLayout.vue?vue&type=script&lang=js"
import style0 from "./SheetLayout.vue?vue&type=style&index=0&id=2ff74628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports